import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getTicketTemplate } from '../../../services/ticketTemplates';
import { ITicketTemplate } from '../../../services/ticketTemplates/types';

interface IProps {
  ticketTemplateId: number;
}

export const ThunkGetTicketTemplate = createAsyncThunk<ITicketTemplate, IProps>(
  `${storeResources.TICKETS}/getTicketTemplate`,
  ({ ticketTemplateId }) => getTicketTemplate(ticketTemplateId).then(res => res.data),
);
